import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Text',
  props: {
  fillColor: {
    type: String,
    required: false,
    default: 'white',
  },
  strokeColor: {
    type: String,
    required: false,
    default: 'white',
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: __props.fillColor,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M16 19C16 18.0681 16 17.6022 16.1522 17.2346C16.3552 16.7446 16.7446 16.3552 17.2346 16.1522C17.6022 16 18.0681 16 19 16H29C29.9319 16 30.3978 16 30.7654 16.1522C31.2554 16.3552 31.6448 16.7446 31.8478 17.2346C32 17.6022 32 18.0681 32 19M21 32H27M24 16V32",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_2)
  ], 8 /* PROPS */, _hoisted_1))
}
}

})